module.exports = __webpack_public_path__ + "media/images/top/mainvisual_pc-9293acd7b72b29bde78777ee7ef864d7.png";